<template>
  <h1>publish account statement</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>